<template>
  <WishlistModal v-if="isOpen" @close="toggle(false)" />
</template>

<script setup lang="ts">
const tracking = useTracking()
const wishlistStore = useWishlistStore()
const { lastUsedWishlist, addToWishlistEvt, deleteFromWishlistEvt } =
  useWishlist()
const auth = useAuthStore()
const authModalEvt = useEventBus<AuthState>('authModal')
const [isOpen, toggle] = useToggle()

onMounted(async () => {
  addToWishlistEvt.on(addToWishlist)
  deleteFromWishlistEvt.on(deleteFromWishlist)
  checkPendingAccomCode()
})

onUnmounted(() => {
  addToWishlistEvt.off(addToWishlist)
  deleteFromWishlistEvt.off(deleteFromWishlist)
})

onCachedPageTransition(wishlistStore.refetch)

async function addToWishlist({ code, editMode }: WishlistEvent) {
  if (!auth.isAuthorized) {
    tracking.handlers?.wishlists.addPropertyRedirect(code)
    auth.setState({ status: true, accomCode: code })
    authModalEvt.emit({ status: true })
    return
  }
  tracking.handlers?.wishlists.addProperty(code)
  wishlistStore.selectAccommodationToAdd(code)

  if (!lastUsedWishlist.value?.id || editMode) {
    toggle(true)
    return
  }

  await wishlistStore.addAccommodationToWishlist({
    wishlistId: lastUsedWishlist.value.id,
    wishlistName: lastUsedWishlist.value.name,
  })
}

function checkPendingAccomCode() {
  const accomCode = localStorage.getItem(auth.pendingAccomCodeKey)

  if (accomCode && auth.isAuthorized) {
    wishlistStore.selectAccommodationToAdd(accomCode)
    toggle(true)
  }
}

async function deleteFromWishlist({ code }: WishlistEvent) {
  await wishlistStore.deleteAccommodationFromWishlist(code)
}
</script>
